import './styles/main.scss';

// Auto-import every component's _style.scss so Vite bundles them with main.css.
const componentStyles = import.meta.glob('../Components/Block*/_style.scss', { eager: true });
void componentStyles;

// Auto-import every component's script.js (for interactive components).
const blockScripts = import.meta.glob('../Components/Block*/script.js', { eager: true });
void blockScripts;

// Sticky header: toggle .is-scrolled when the user moves past the hero so the
// transparent-over-hero treatment hands off to a solid bg further down. The
// hero/page also dictates the initial light/dark text via .mainHeader--light.
const header = document.querySelector('.mainHeader');
if (header) {
  const onScroll = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 16);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  // Mobile nav toggle. The CSS sibling selector
  // `.mainHeader__toggle[aria-expanded="true"] + .mainHeader__navWrap`
  // does the actual reveal; the JS just flips the attribute and closes
  // the drawer when the user taps a link.
  const toggle = header.querySelector('.mainHeader__toggle');
  const navWrap = header.querySelector('.mainHeader__navWrap');
  if (toggle && navWrap) {
    const setOpen = (open) => {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      // Lock body scroll while the full-screen drawer is up so the
      // background doesn't accidentally scroll under the open menu.
      document.documentElement.classList.toggle('is-nav-open', open);
    };
    toggle.addEventListener('click', () => {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });
    navWrap.addEventListener('click', (event) => {
      if (event.target instanceof HTMLAnchorElement) {
        setOpen(false);
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
        toggle.focus();
      }
    });
  }
}

// Scroll-to-top button. Rendered (hidden) by the template only on pages where
// the editor has it enabled; it reveals itself once the visitor scrolls a
// screenful down and smooth-scrolls back to the top on click.
const scrollTopBtn = document.querySelector('.scrollTop');
if (scrollTopBtn) {
  const threshold = () => window.innerHeight * 0.75;
  const sync = () => {
    const show = window.scrollY > threshold();
    scrollTopBtn.hidden = !show;
    scrollTopBtn.classList.toggle('is-visible', show);
  };
  sync();
  window.addEventListener('scroll', sync, { passive: true });
  scrollTopBtn.addEventListener('click', () => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });
}
